import he from './he';

const languages = { he };

export default languages;
